import api from '../../../../utils/api'
import { useState, useEffect } from "react"
import { FiInbox } from 'react-icons/fi'

/* input */
import Input from '../../../../shared/components/form/input'
import ListAccessoryRow from '../../../accessory/ListRow/ListAccessoryRow'

function ListAccessoryBudget({ handleSelect }) {
    const [accessories, setAccessories] = useState([])
    const [token] = useState(localStorage.getItem('token') || '')
    const [load, setLoad] = useState(false)

    //--------------------SEARCH-----------------------
    const [search, setSearch] = useState('')

    const searchLowerCase = search.toLowerCase()
    const searchArray = accessories.filter((item) => item.name.toLowerCase().includes(searchLowerCase))
    function handleOnSearch(e) {
        setSearch(e.target.value)
    }

    //-------------------------------------------------
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const getAll = () => {
        api.get(`accessory/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {
            if (response.data) {
                setAccessories(response.data.accessories)
                setLoad(true)
            }
        })
    }

    if (!load) {
        return <div className="pg-loading">Carregando acessórios...</div>
    }

    return (
        <section className="pg-page">
            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Adicionar Acessório</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por nome..."
                                    value={search}
                                    handleOnChange={handleOnSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {searchArray.length} {searchArray.length === 1 ? 'acessório' : 'acessórios'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {searchArray.length > 0 ? (
                    <ListAccessoryRow dataArray={searchArray} myPermissionView={true} enableSelect={true} handleSelect={handleSelect} />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum acessório encontrado</p>
                        <p className="pg-empty-subtitle">
                            {accessories.length === 0 ? 'Não há acessórios cadastrados.' : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>
        </section>
    )
}

export default ListAccessoryBudget
